import { CSVLink } from 'react-csv';

import { DATE_TIME_FORMAT } from '../../../constants';
import { getFormattedPhoneNumber } from '../../../helpers';
import { PanelEditContact } from '../../CallCenter';
import { Button, ButtonCallNotes, ButtonGoBack } from '../../Shared';

export const AppointmentInformation = ({
  timeInfo,
  pickerInfo,
  appointment,
  formCallNotes,
  lead,
  setIndex,
  getUserTimeZone,
  handleFinishCall,
  handleOpenCallNotesModal,
  handleOpenEditContactModal,
  isDialOutcomesLoading,
}) => {
  const csvData = [
    [
      'LeadID',
      'Company Name',
      'Contact Name',
      'Title',
      'Industry',
      'Country',
      'State',
      'City',
      'Contact Address',
      'Zip Code',
      'Time Zone',
      'Email',
      'Linkedin',
      'Website',
      'Appt Date',
      'Appt Time',
      'Appt Type',
      'Best Phone',
    ],
    [
      lead.leadid,
      lead.company,
      lead.contact,
      lead.title,
      lead.industry,
      lead.country,
      lead.state,
      lead.city,
      lead.address,
      lead.zip,
      lead.time,
      lead.email,
      lead.linkedin,
      lead.website,
      pickerInfo.format(DATE_TIME_FORMAT.MM_DD_YYYY),
      `${timeInfo} ${getUserTimeZone()}`,
      appointment,
      lead.bestPhone,
    ],
  ];

  return (
    <div className="flex flex-col rounded-2xl bg-secondary/10 p-3 2xl:p-10">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b-[3px] border-secondary/20 pb-2">
        <div className="relative flex items-center gap-2 before:absolute before:-bottom-[11px] before:left-0 before:h-[3px] before:w-[calc(100%+.5rem)] before:bg-secondary">
          <span className="rounded-lg bg-accent-1 p-1 text-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              fill="currentColor"
              className="h-5 w-5"
            >
              <path d="M14.69 14.05a6.91 6.91 0 0 0-3.12-2.48A4.23 4.23 0 0 0 13 9.47a4.15 4.15 0 1 0-8 0 4.23 4.23 0 0 0 1.42 2.1 6.91 6.91 0 0 0-3.12 2.48 7.62 7.62 0 1 1 11.38 0ZM6.23 8.31a2.78 2.78 0 0 1 1.71-2.56 2.74 2.74 0 0 1 1.6-.16 2.78 2.78 0 0 1 2.18 2.18A2.78 2.78 0 0 1 9 11.08a2.77 2.77 0 0 1-2.77-2.77ZM4.33 15a5.55 5.55 0 0 1 9.34 0 7.58 7.58 0 0 1-9.34 0ZM9 0a9 9 0 1 0 6.36 2.64A9 9 0 0 0 9 0Z" />
            </svg>
          </span>
          <h6 className="text-lg font-medium">Appointment Information</h6>
        </div>
        <CSVLink
          data={csvData}
          filename={'ContactInfo.csv'}
          className="flex h-[28px] w-[28px] items-center justify-center rounded-lg border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z"
              clipRule="evenodd"
            />
          </svg>
        </CSVLink>
      </div>
      <div className="mt-10 mx-4 mb-6 flex h-full flex-col justify-between gap-3">
        <PanelEditContact lead={lead} action={handleOpenEditContactModal} />
        <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
          <div className="flex items-center justify-end">
            <a
              href={`mailto:${lead.email}`}
              name={'email'}
              className="flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="h-5 w-5"
              >
                <path d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
                <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
              </svg>
            </a>
            <a
              href={`${lead.linkedin}`}
              target="_blank"
              name={'linkedin'}
              className="flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                fill="currentColor"
                className="h-6 w-6"
              >
                <path d="M7.5 5A2.518 2.518 0 0 0 5 7.5v17C5 25.867 6.133 27 7.5 27h17c1.367 0 2.5-1.133 2.5-2.5v-17C27 6.133 25.867 5 24.5 5Zm0 2h17c.285 0 .5.215.5.5v17a.49.49 0 0 1-.5.5h-17a.489.489 0 0 1-.5-.5v-17c0-.285.215-.5.5-.5Zm2.938 1.719a1.719 1.719 0 1 0 0 3.437 1.719 1.719 0 0 0 0-3.437Zm9.03 4.562c-1.433 0-2.386.785-2.78 1.531h-.063V13.5h-2.813V23h2.938v-4.688c0-1.238.246-2.437 1.781-2.437 1.512 0 1.532 1.398 1.532 2.5V23H23v-5.219c0-2.554-.543-4.5-3.531-4.5ZM9 13.5V23h2.969v-9.5Z" />
              </svg>
            </a>
            <a
              href={`${lead.website}`}
              target="_blank"
              name={'website'}
              className="flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="h-5 w-5"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20M2 12h20" />
              </svg>
            </a>
          </div>
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="font-medium text-gray-500 text-sm">
                Contact Name
              </span>
              <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                {lead.contact}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-500 text-sm">Title</span>
              <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                {lead.title}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-500 text-sm">
                Company Name
              </span>
              <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                {lead.company}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-500 text-sm">
                Industry
              </span>
              <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                {lead.industry}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-2 xl:grid-cols-2">
              <div className="flex flex-col">
                <span className="font-medium text-gray-500 text-sm">
                  Best Phone
                </span>
                <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                  {getFormattedPhoneNumber(lead.bestPhone)}
                </span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 md:grid-cols-3 xl:grid-cols-3">
              <div className="flex flex-col">
                <span className="font-medium text-gray-500 text-sm">
                  Appt Date
                </span>
                <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                  {pickerInfo.format(DATE_TIME_FORMAT.MM_DD_YYYY)}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-medium text-gray-500 text-sm">
                  Appt Time
                </span>
                <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                  {`${timeInfo} ${getUserTimeZone()}`}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-medium text-gray-500 text-sm">
                  Appointment Type
                </span>
                <span className="text-sm font-medium border-b-secondary/20 border-b-2 pb-2">
                  {appointment}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
          <ButtonGoBack
            onClick={() => {
              setIndex(4);
            }}
            disabled={isDialOutcomesLoading}
          />
          <Button
            title="Finish"
            onClick={handleFinishCall}
            disabled={isDialOutcomesLoading}
          />
          <ButtonCallNotes
            onClick={handleOpenCallNotesModal}
            hasBg={formCallNotes && formCallNotes !== 'null'}
            disabled={isDialOutcomesLoading}
          />
        </div>
      </div>
    </div>
  );
};
